import BaseModel from '../core/BaseModel'

export default class OfficeVPLKTplModel extends BaseModel {

    constructor() {
        super({
                name: "office_vplk_tpl",
                tableName: 'office_vplk_tpl',
                label: "office_vplk_tpl",
                display_key: 'id',
                default_order: {key: 'id', direction: 'asc'}
            },
            {
                office_vplk_id: {
                    name: 'office_vplk_id',
                    type: "Int",
                    label: 'office_vplk_id',
                    width: 15,
                    class: "center",
                    filter: {type: 'input', match: 'contains'},
                    display: false
                },
                office_tpl_id: {
                    name: 'office_tpl_id',
                    type: "Int",
                    label: 'office_tpl_id',
                    width: 15,
                    class: "center",
                    filter: {type: 'input', match: 'contains'},
                    display: false
                },
            },)
    }

}